/**
 * Fortune Telling CTA - Enhanced Features
 * Enhanced features: Camera/Gallery selection, Chinese-style loading animation, Report generation, Product recommendations
 */

// ==================== Photo Upload Enhancement ====================

/**
 * Initialize enhanced photo upload (supports camera and gallery)
 */
function initEnhancedPhotoUpload() {
  const photoInput = document.getElementById('palmPhoto');
  const uploadArea = document.getElementById('photoUploadArea');
  const uploadPlaceholder = document.getElementById('uploadPlaceholder');
  
  if (!photoInput || !uploadArea) return;
  
  // Create button container
  const buttonContainer = document.createElement('div');
  buttonContainer.className = 'photo-upload-buttons';
  buttonContainer.style.cssText = 'display: flex; gap: 1rem; justify-content: center; margin-top: 1rem;';
  
  // Camera button
  const cameraBtn = document.createElement('button');
  cameraBtn.type = 'button';
  cameraBtn.innerHTML = '📷 Take Photo';
  cameraBtn.style.cssText = `
    background: linear-gradient(135deg, #d4af37, #c9a247);
    border: none;
    color: #1a1a1a;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s ease;
    flex: 1;
    max-width: 150px;
  `;
  
  // Gallery button
  const galleryBtn = document.createElement('button');
  galleryBtn.type = 'button';
  galleryBtn.innerHTML = '🖼️ Gallery';
  galleryBtn.style.cssText = cameraBtn.style.cssText;
  
  // Click events
  cameraBtn.addEventListener('click', () => {
    photoInput.setAttribute('capture', 'environment');
    photoInput.click();
  });
  
  galleryBtn.addEventListener('click', () => {
    photoInput.removeAttribute('capture');
    photoInput.click();
  });
  
  // Hover effects
  [cameraBtn, galleryBtn].forEach(btn => {
    btn.addEventListener('mouseenter', () => {
      btn.style.transform = 'translateY(-2px)';
      btn.style.boxShadow = '0 4px 12px rgba(212, 175, 55, 0.4)';
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transform = 'translateY(0)';
      btn.style.boxShadow = 'none';
    });
  });
  
  buttonContainer.appendChild(cameraBtn);
  buttonContainer.appendChild(galleryBtn);
  
  // Add to upload area
  if (uploadPlaceholder && !uploadPlaceholder.querySelector('.photo-upload-buttons')) {
    uploadPlaceholder.appendChild(buttonContainer);
  }
  
  // Remove original click upload function
  uploadArea.style.cursor = 'default';
  uploadArea.onclick = null;
}

// ==================== Chinese-Style Loading Animation ====================

/**
 * Show Chinese-style analysis animation (3-5 seconds)
 */
function showChineseLoadingAnimation() {
  // Create overlay
  const overlay = document.createElement('div');
  overlay.id = 'fortune-loading-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.95);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    animation: fadeIn 0.5s ease;
  `;
  
  // Create animation container
  const container = document.createElement('div');
  container.style.cssText = `
    text-align: center;
    color: #f4e4c1;
    max-width: 500px;
    padding: 2rem;
  `;
  
  // ✨ 中国风金色太极图 - 使用SVG替代emoji
  const bagua = document.createElement('div');
  bagua.innerHTML = `
    <svg width="140" height="140" viewBox="0 0 200 200" style="filter: drop-shadow(0 0 30px rgba(212, 175, 55, 0.8));">
      <!-- 外圆金边 -->
      <circle cx="100" cy="100" r="95" fill="none" stroke="#d4af37" stroke-width="3" opacity="0.8"/>
      
      <!-- 太极主体 -->
      <g style="animation: spin 3s linear infinite; transform-origin: center;">
        <!-- 阴阳分界（S形曲线） -->
        <path d="M 100,5 A 47.5,47.5 0 0,1 100,100 A 47.5,47.5 0 0,0 100,195 A 95,95 0 0,1 100,5 Z" 
              fill="#d4af37" stroke="none"/>
        <path d="M 100,5 A 47.5,47.5 0 0,0 100,100 A 47.5,47.5 0 0,1 100,195 A 95,95 0 0,0 100,5 Z" 
              fill="#1a1a1a" stroke="none"/>
        
        <!-- 上方小圆（阴中有阳） -->
        <circle cx="100" cy="52.5" r="15" fill="#1a1a1a"/>
        
        <!-- 下方小圆（阳中有阴） -->
        <circle cx="100" cy="147.5" r="15" fill="#d4af37"/>
        
        <!-- 金色光晕效果 -->
        <circle cx="100" cy="100" r="95" fill="none" stroke="url(#goldGradient)" stroke-width="2" opacity="0.3"/>
      </g>
      
      <!-- 渐变定义 -->
      <defs>
        <radialGradient id="goldGradient">
          <stop offset="0%" style="stop-color:#d4af37;stop-opacity:0.8" />
          <stop offset="50%" style="stop-color:#f4e4c1;stop-opacity:0.5" />
          <stop offset="100%" style="stop-color:#d4af37;stop-opacity:0.2" />
        </radialGradient>
      </defs>
    </svg>
  `;
  bagua.style.cssText = `
    margin-bottom: 2rem;
    display: inline-block;
  `;
  
  // Analysis text
  const texts = [
    'Reading your destiny path...',
    'Analyzing five elements balance...',
    'Calculating fortune trajectory...',
    'Revealing your future secrets...'
  ];
  
  const textElement = document.createElement('div');
  textElement.style.cssText = `
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 600;
    color: #d4af37;
    min-height: 2em;
  `;
  
  const subText = document.createElement('div');
  subText.style.cssText = `
    font-size: 1rem;
    color: rgba(244, 228, 193, 0.7);
    font-style: italic;
  `;
  subText.textContent = 'Please wait, the master is divining for you...';
  
  // Particle effects
  const particles = document.createElement('div');
  particles.style.cssText = `
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: none;
  `;
  
  for (let i = 0; i < 20; i++) {
    const particle = document.createElement('div');
    particle.textContent = ['✨', '⭐', '💫'][Math.floor(Math.random() * 3)];
    particle.style.cssText = `
      position: absolute;
      font-size: ${Math.random() * 20 + 10}px;
      left: ${Math.random() * 100}%;
      top: ${Math.random() * 100}%;
      opacity: ${Math.random() * 0.5 + 0.3};
      animation: float ${Math.random() * 3 + 2}s ease-in-out infinite;
      animation-delay: ${Math.random() * 2}s;
    `;
    particles.appendChild(particle);
  }
  
  // Assemble
  container.appendChild(bagua);
  container.appendChild(textElement);
  container.appendChild(subText);
  overlay.appendChild(particles);
  overlay.appendChild(container);
  document.body.appendChild(overlay);
  
  // Text carousel
  let textIndex = 0;
  const textInterval = setInterval(() => {
    textElement.style.opacity = '0';
    setTimeout(() => {
      textElement.textContent = texts[textIndex];
      textElement.style.opacity = '1';
      textIndex = (textIndex + 1) % texts.length;
    }, 300);
  }, 1500);
  
  // Add CSS animations
  if (!document.getElementById('fortune-animations')) {
    const style = document.createElement('style');
    style.id = 'fortune-animations';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
      @keyframes float {
        0%, 100% { transform: translateY(0) translateX(0); }
        25% { transform: translateY(-20px) translateX(10px); }
        50% { transform: translateY(-10px) translateX(-10px); }
        75% { transform: translateY(-30px) translateX(5px); }
      }
    `;
    document.head.appendChild(style);
  }
  
  // Remove after 3-5 seconds (random)
  const duration = Math.random() * 2000 + 3000; // 3000-5000ms
  
  return new Promise((resolve) => {
    setTimeout(() => {
      clearInterval(textInterval);
      overlay.style.animation = 'fadeOut 0.5s ease';
      overlay.style.opacity = '0';
      setTimeout(() => {
        overlay.remove();
        resolve();
      }, 500);
    }, duration);
  });
}

// ==================== Report Generation (Encouraging Version) ====================

/**
 * Generate encouraging fortune report with gentle 2026 energy mention
 */
function generateFortuneReport(formData) {
  const { gender, aspects } = formData;
  
  // Positive fortune insights
  const fortuneInsights = {
    wealth: [
      '💰 Your wealth palace shows strong potential for prosperity. Natural ability to attract financial opportunities.',
      '✨ Excellent financial intuition detected. You have the gift to recognize valuable opportunities.',
      '🌟 Strong wealth foundation in your destiny. Your efforts will be rewarded abundantly.'
    ],
    love: [
      '💖 Your love line indicates a warm and compassionate heart. You attract genuine connections.',
      '🌹 Beautiful emotional energy surrounds you. Romance and harmony flow naturally in your life.',
      '💝 Strong romantic potential ahead. Your authentic nature draws kindred spirits to you.'
    ],
    health: [
      '🌿 Your vitality signs are encouraging. Natural resilience and strong life force detected.',
      '💪 Excellent health foundation. Your body has remarkable self-healing capabilities.',
      '✨ Positive health energy flows through you. Balanced constitution and good vitality.'
    ],
    career: [
      '🎯 Strong career potential detected. Your talents will bring recognition and success.',
      '⭐ Natural leadership qualities shine through. Great opportunities await your ambitions.',
      '🚀 Excellent professional prospects. Your dedication will open many doors.'
    ]
  };
  
  // Generate report
  let report = '';
  
  // Positive analysis
  report += `<div style="background: linear-gradient(135deg, rgba(212, 175, 55, 0.15), rgba(201, 162, 71, 0.15)); border-left: 4px solid #d4af37; padding: 1.5rem; margin-bottom: 2rem; border-radius: 8px; box-shadow: 0 2px 10px rgba(212, 175, 55, 0.2);">`;
  report += `<h3 style="color: #d4af37; margin-bottom: 1rem; font-size: 1.3rem;">🔮 Your Destiny Analysis</h3>`;
  report += `<p style="color: #f4e4c1; line-height: 1.8; margin-bottom: 1rem;">`;
  report += `Congratulations! Your palm reading reveals a ${gender === 'male' ? 'strong and purposeful' : 'graceful and intuitive'} energy signature. `;
  report += `You possess unique gifts in the areas of ${aspects.join(', ')}. Your destiny holds great promise!`;
  report += `</p></div>`;
  
  // Positive insights for each aspect
  report += `<div style="background: rgba(212, 175, 55, 0.08); padding: 1.5rem; margin-bottom: 2rem; border-radius: 10px;">`;
  
  aspects.forEach((aspect, index) => {
    const insights = fortuneInsights[aspect] || [];
    const insight = insights[Math.floor(Math.random() * insights.length)];
    report += `<div style="margin-bottom: ${index < aspects.length - 1 ? '1.5rem' : '0'};">`;
    report += `<p style="color: #f4e4c1; line-height: 1.8; font-size: 1.05rem;">${insight}</p>`;
    report += `</div>`;
  });
  
  report += `</div>`;
  
  // Gentle 2026 energy note + product recommendation
  report += `<div style="background: rgba(212, 175, 55, 0.12); border: 1px solid #d4af37; padding: 1.5rem; border-radius: 10px; margin-bottom: 2rem;">`;
  report += `<h3 style="color: #d4af37; margin-bottom: 1rem; font-size: 1.2rem;">✨ 2026 Energy Enhancement Tip</h3>`;
  report += `<p style="color: #f4e4c1; line-height: 1.8; margin-bottom: 1rem;">`;
  report += `As we navigate through 2026, the cosmic energies are shifting in fascinating ways. To maintain your positive momentum and amplify your natural strengths, `;
  report += `consider enhancing your energy field with our specially curated mystical accessories.`;
  report += `</p>`;
  report += `<p style="color: #f4e4c1; line-height: 1.8;">`;
  report += `Our <strong style="color: #d4af37;">heart-chosen collections</strong> combined with the <strong style="color: #d4af37;">recommended items below</strong> work synergistically to `;
  report += `<strong style="color: #d4af37;">amplify energy absorption and maintain your positive flow</strong>. Think of them as your personal energy companions!`;
  report += `</p></div>`;
  
  return report;
}

// ==================== Product Recommendation Module ====================

/**
 * Fetch and display Shopify product information
 */
async function fetchAndDisplayProduct(productHandle) {
  try {
    console.log(`🛍️ Fetching product: ${productHandle}`);
    const response = await fetch(`/products/${productHandle}.js`);
    
    if (!response.ok) {
      console.error(`❌ Product not found: ${productHandle} (${response.status})`);
      throw new Error(`Product not found: ${productHandle}`);
    }
    
    const product = await response.json();
    console.log(`✅ Product fetched:`, product.title);
    console.log(`- Image:`, product.featured_image);
    console.log(`- Price:`, product.price);
    console.log(`- URL:`, product.url);
    
    // Get product image (try multiple sources)
    let productImage = product.featured_image;
    
    // If no featured_image, try to get from images array
    if (!productImage && product.images && product.images.length > 0) {
      productImage = product.images[0];
      console.log(`ℹ️ Using first image from images array:`, productImage);
    }
    
    // If still no image, try media
    if (!productImage && product.media && product.media.length > 0) {
      productImage = product.media[0].src || product.media[0].preview_image?.src;
      console.log(`ℹ️ Using first media image:`, productImage);
    }
    
    if (!productImage) {
      console.warn(`⚠️ No image found for product: ${productHandle}`);
      productImage = 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';
    }
    
    return {
      title: product.title,
      image: productImage,
      price: (product.price / 100).toFixed(2),
      url: product.url,
      available: product.available
    };
  } catch (error) {
    console.error(`❌ Failed to fetch product ${productHandle}:`, error);
    return null;
  }
}

/**
 * Create product recommendation card - 移动端响应式版本
 */
function createProductCard(product) {
  if (!product) return '';
  
  // 检测是否为移动设备
  const isMobile = window.innerWidth <= 768;
  
  return `
    <a href="${product.url}" style="
      display: block;
      background: rgba(212, 175, 55, 0.1);
      border: 2px solid #d4af37;
      border-radius: 12px;
      padding: ${isMobile ? '1rem' : '1.5rem'};
      text-decoration: none;
      transition: all 0.3s ease;
      margin-bottom: 1rem;
    " class="product-recommendation-card">
      <div style="
        display: flex; 
        flex-direction: ${isMobile ? 'column' : 'row'};
        gap: ${isMobile ? '1rem' : '1.5rem'}; 
        align-items: ${isMobile ? 'stretch' : 'center'};
      ">
        <img src="${product.image}" alt="${product.title}" style="
          width: ${isMobile ? '100%' : '120px'};
          height: ${isMobile ? 'auto' : '120px'};
          max-height: ${isMobile ? '200px' : '120px'};
          object-fit: cover;
          border-radius: 8px;
          border: 2px solid #d4af37;
        ">
        <div style="flex: 1; ${isMobile ? 'text-align: center;' : ''}">
          <h4 style="color: #d4af37; margin-bottom: 0.5rem; font-size: ${isMobile ? '1rem' : '1.2rem'};">${product.title}</h4>
          <div style="color: #f4e4c1; font-size: ${isMobile ? '1.3rem' : '1.5rem'}; font-weight: 700; margin-bottom: 0.5rem;">
            $${product.price}
          </div>
          <div style="
            display: inline-block;
            background: linear-gradient(135deg, #d4af37, #c9a247);
            color: #1a1a1a;
            padding: ${isMobile ? '0.75rem 1.25rem' : '0.5rem 1.5rem'};
            border-radius: 6px;
            font-weight: 600;
            margin-top: 0.5rem;
            font-size: ${isMobile ? '0.95rem' : '1rem'};
          ">
            ${product.available ? 'Shop Now →' : 'Out of Stock'}
          </div>
        </div>
      </div>
    </a>
  `;
}

/**
 * Display product recommendations section
 */
async function displayProductRecommendations(productHandles, introText) {
  console.log('📦 displayProductRecommendations called');
  console.log('- productHandles:', productHandles);
  console.log('- introText:', introText);
  
  if (!productHandles || productHandles.length === 0) {
    console.warn('⚠️ No product handles provided');
    return '';
  }
  
  // 检测是否为移动设备
  const isMobile = window.innerWidth <= 768;
  
  let html = '';
  
  // Introduction text
  html += `<div style="background: linear-gradient(135deg, rgba(212, 175, 55, 0.2), rgba(201, 162, 71, 0.2)); border: 3px solid #d4af37; padding: ${isMobile ? '1.5rem' : '2rem'}; margin: 2rem 0; border-radius: 12px; box-shadow: 0 4px 20px rgba(212, 175, 55, 0.3);">`;
  html += `<h3 style="color: #d4af37; margin-bottom: 1.5rem; font-size: ${isMobile ? '1.25rem' : '1.5rem'}; text-align: center;">🌟 Master's Special Recommendations 🌟</h3>`;
  html += `<p style="color: #f4e4c1; line-height: 1.8; font-size: ${isMobile ? '0.95rem' : '1.1rem'}; margin-bottom: 2rem; text-align: center; font-weight: 500;">`;
  html += introText || 'Based on the fortune report above, we strongly recommend that in addition to wearing energy jewelry, you should also combine the following products for the best comprehensive energy shield solution';
  html += `</p>`;
  
  // Fetch and display products
  let productsAdded = 0;
  for (const handle of productHandles) {
    console.log(`🔄 Processing product handle: ${handle}`);
    const product = await fetchAndDisplayProduct(handle);
    if (product) {
      const cardHTML = createProductCard(product);
      html += cardHTML;
      productsAdded++;
      console.log(`✅ Product card added (${productsAdded}/${productHandles.length})`);
    } else {
      console.warn(`⚠️ Product card not created for handle: ${handle}`);
    }
  }
  
  html += `</div>`;
  
  console.log(`📦 Recommendations HTML generated`);
  console.log(`- Total products added: ${productsAdded}/${productHandles.length}`);
  console.log(`- HTML length: ${html.length} characters`);
  
  return html;
}

// ==================== Export Functions ====================

window.FortuneEnhancements = {
  initEnhancedPhotoUpload,
  showChineseLoadingAnimation,
  generateFortuneReport,
  displayProductRecommendations
};
